import { browser } from '$app/environment'
import type { LayoutLoad } from './$types'
import '$lib/i18n' // Import to initialize
import { locale, waitLocale } from 'svelte-i18n'

export const prerender = false
export const ssr = false

export const load: LayoutLoad = async () => {
    if (browser) {
        const savedLocale = localStorage.getItem('language')
        if (savedLocale) {
            locale.set(savedLocale)
        }
        await waitLocale()
    }
    return {}
}
